import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=defd28ea&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('defd28ea')) {
      api.createRecord('defd28ea', component.options)
    } else {
      api.reload('defd28ea', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=defd28ea&", function () {
      api.rerender('defd28ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4dIZo30Cy2dfL/JS/comp/ErrorMessage.vue"
export default component.exports